import { GET_AXON_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export type TPostBulkUploadServicesMasterRequestProps = {
  servicesFile: File;
  clinic_id: string;
};

export default async function postBulkUploadServicesMaster({
  servicesFile,
  clinic_id,
}: TPostBulkUploadServicesMasterRequestProps): Promise<
  AxonGenericApiResponse<{}>
> {
  const AXON_HOST = GET_AXON_HOST();
  const myHeaders = new Headers();

  const formData = new FormData();
  formData.append("services-master", servicesFile);
  formData.append("clinic_id", clinic_id);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
    body: formData,
  };

  const response = await fetch(
    `${AXON_HOST}/autosuggest/bulk-upload/services-master`,
    requestOptions
  );
  return await response.json();
}
